import { useState, useEffect, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import Request from '../../../shared/request/Request';
import ToasterHelper from '../../../shared/helpers/toaster.helper';
import { API } from '../../../shared/constants/API';
import { HttpStatusCode } from '../../../shared/request/HttpStatusCode';
import { /*LuDollarSign,*/ LuUsers, LuNewspaper, LuBookOpenCheck } from 'react-icons/lu';
import { Dropdown } from 'primereact/dropdown';
import { Calendar } from 'primereact/calendar';
import { Nullable } from 'primereact/ts-helpers';

import { getItem } from '../../../services/session-storage.service';
import Redirect from '../../redirect/redirect';

const BackOfficeReports = () => {
  const { t } = useTranslation();
  const token = getItem('token');
  const [loaded, setLoaded] = useState(false);
  const [dates, setDates] = useState<Nullable<(Date | null)[]>>(null);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const periods = [
    { label: t('BACK_OFFICE.REPORTS.PERIODS_RANGE.7_DAYS'), value: 7 },
    { label: t('BACK_OFFICE.REPORTS.PERIODS_RANGE.30_DAYS'), value: 30 },
    { label: t('BACK_OFFICE.REPORTS.PERIODS_RANGE.90_DAYS'), value: 90 },
    { label: t('BACK_OFFICE.REPORTS.PERIODS_RANGE.180_DAYS'), value: 180 },
    { label: t('BACK_OFFICE.REPORTS.PERIODS_RANGE.365_DAYS'), value: 365 },
    { label: t('BACK_OFFICE.REPORTS.PERIODS_RANGE.CUSTOM_DAYS'), value: 0 }
  ];
  const [selectedPeriod, setSelectedPeriod] = useState<number>(periods[0].value);
  const [userData, setUserData] = useState<any>(null);
  const [newsletterData, setNewsletterData] = useState<any>(null);

  const today = new Date();
  const minDate = new Date();
  minDate.setFullYear(today.getFullYear() - 1);

  const onPeriodChange = (e: { value: number }) => {
    setSelectedPeriod(e.value);
    setDates(null);
    loadUsersStatsData(e.value);
    loadNewslettersStatsData(e.value);
  };

  const onChangeDates = (e: { value: (Date | null)[] }) => {
    setSelectedPeriod(0);
    setDates(e.value ? e.value : null);
    if (e.value != null) {
      const start = new Date(e.value[0]);
      const end = new Date(e.value[1]);
      const days = Math.floor((end.getTime() - start.getTime()) / (1000 * 3600 * 24) + 1);
      loadUsersStatsData(days);
      loadNewslettersStatsData(days);
    }
  };

  const loadUsersStatsData = useCallback(
    async (period: number) => {
      Request.get(`${API.BACK_OFFICE_SERVICE}/getUsersStats?days=${period}`, {})
        .then((response: any) => {
          if (response.status.toString() === HttpStatusCode.OK) {
            setUserData(response.body);
          } else {
            if (response.status.toString() === HttpStatusCode.TOO_MANY_REQUESTS) {
              ToasterHelper.notify(t('ERRORS.TRY_AGAIN_LATER'), 'info');
            }
            return [];
          }
        })
        .catch(error => {
          ToasterHelper.notify(t('ERRORS.AN_ERROR_OCCURRED'), 'error');
          console.log(error);
          return [];
        });
    },
    [t]
  );

  const loadNewslettersStatsData = useCallback(
    async (period: number) => {
      Request.get(`${API.BACK_OFFICE_SERVICE}/getNewslettersStats?days=${period}`, {})
        .then((response: any) => {
          if (response.status.toString() === HttpStatusCode.OK) {
            setNewsletterData(response.body);
          } else {
            if (response.status.toString() === HttpStatusCode.TOO_MANY_REQUESTS) {
              ToasterHelper.notify(t('ERRORS.TRY_AGAIN_LATER'), 'info');
            }
            return [];
          }
        })
        .catch(error => {
          ToasterHelper.notify(t('ERRORS.AN_ERROR_OCCURRED'), 'error');
          console.log(error);
          return [];
        });
    },
    [t]
  );

  useEffect(() => {
    if (!loaded) {
      setLoaded(true);
      loadUsersStatsData(periods[0].value);
      loadNewslettersStatsData(periods[0].value);
    }
  }, [loadUsersStatsData, loadNewslettersStatsData, periods, loaded]);

  return (
    <>
      {!token && <Redirect path='/back-office/signin' />}
      <div>
        <div className='main-div'>
          <div className='main-content'>
            <h3>{t('BACK_OFFICE.REPORTS.REPORTS')}</h3>
            <div className='col-md-12 flex margin-before-20px'>
              <div className='col-md-3'>
                <div className='mb-2 font-bold-700'>{t('BACK_OFFICE.REPORTS.SELECT_PERIOD')}</div>
                <Dropdown
                  value={selectedPeriod}
                  options={periods}
                  onChange={onPeriodChange}
                  placeholder={t('BACK_OFFICE.REPORTS.SELECT_PERIOD')}
                  style={{ width: '100%' }}
                />
              </div>
              <div className='col-md-3' style={{ marginLeft: '20px' }}>
                <div className='mb-2 font-bold-700'>{t('BACK_OFFICE.REPORTS.DATE_RANGE')}</div>
                <Calendar
                  value={dates}
                  onChange={onChangeDates}
                  onClearButtonClick={e => setDates(null)}
                  selectionMode='range'
                  readOnlyInput
                  hideOnRangeSelection
                  maxDate={today}
                  minDate={minDate}
                  placeholder={t('BACK_OFFICE.REPORTS.SELECT_RANGE')}
                  showButtonBar={true}
                  style={{ width: '100%' }}
                />
              </div>
            </div>
            <div className='col-md-12 flex mt-5'>
              {/*<div className='reports-total-revenue col-md-3'>
                <div className='col-md-12 flex'>
                  <div className='col-md-1'>
                    <h4>
                      <LuDollarSign />
                    </h4>
                  </div>
                  <div className='col-md-11 right-align-text'>{t('BACK_OFFICE.REPORTS.TOTAL_REVENUE')}</div>
                </div>
                <p />
                <div className='col-md-12 flex'>
                  <h3 className='font-bold-700'>$1,500</h3>
                </div>
                <div className='col-md-12 flex'>+5% from last month</div>
              </div>*/}
              <div className='reports-subscribers col-md-3'>
                <div className='col-md-12 flex bg-blue-50 min-h-10'>
                  <div className='col-md-1 content-center'>
                    <h4>
                      <LuBookOpenCheck />
                    </h4>
                  </div>
                  <div className='col-md-11 right-align-text ml-5 text-blue-700 content-center'>{t('BACK_OFFICE.REPORTS.NEW_USERS')}</div>
                </div>
                <p />
                <div className='col-md-4 flex'>
                  <h3 className='font-bold-700'>{userData?.total_new_users}</h3>
                </div>
                <div className='col-md-12 flex'></div>
              </div>
              <div className='reports-active-athletes col-md-3'>
                <div className='col-md-12 flex bg-blue-50 min-h-10'>
                  <div className='col-md-1 content-center'>
                    <h4>
                      <LuUsers />
                    </h4>
                  </div>
                  <div className='col-md-11 right-align-text ml-5 text-blue-700 content-center'>
                    {t('BACK_OFFICE.REPORTS.ACTIVE_USERS')}
                  </div>
                </div>
                <p />
                <div className='col-md-12 flex'>
                  <h3 className='font-bold-700'>{userData?.active.count}</h3>
                </div>
                <div className='col-md-12 flex'>+3% from last month</div>
              </div>
              <div className='reports-in-active-athletes col-md-3'>
                <div className='col-md-12 flex bg-blue-50 min-h-10'>
                  <div className='col-md-1 content-center'>
                    <h4>
                      <LuUsers />
                    </h4>
                  </div>
                  <div className='col-md-11 right-align-text ml-5 text-blue-700 content-center'>
                    {t('BACK_OFFICE.REPORTS.INACTIVE_USERS')}
                  </div>
                </div>
                <p />
                <div className='col-md-12 flex'>
                  <h3 className='font-bold-700'>{userData?.inactive.count}</h3>
                </div>
                <div className='col-md-12 flex'>{/*+3% from last month*/}</div>
              </div>
            </div>
            <div className='col-md-12 flex mt-15'>
              <div className='reports-active-athletes col-md-3'>
                <div className='col-md-12 flex bg-blue-50 min-h-10'>
                  <div className='col-md-1 content-center'>
                    <h4>
                      <LuNewspaper />
                    </h4>
                  </div>
                  <div className='col-md-11 right-align-text ml-5 text-blue-700 content-center'>{t('BACK_OFFICE.REPORTS.NEWSLETTERS')}</div>
                </div>
                <p />
                <div className='col-md-12 flex'>
                  <h3 className='font-bold-700'>{newsletterData?.total_newsletters}</h3>
                </div>
                <div className='col-md-12 flex'>{/*+3% from last month*/}</div>
              </div>
              <div className='reports-in-active-athletes col-md-3'>
                <div className='col-md-12 flex bg-blue-50 min-h-10'>
                  <div className='col-md-1 content-center'>
                    <h4>
                      <LuUsers />
                    </h4>
                  </div>
                  <div className='col-md-11 right-align-text ml-5 text-blue-700 content-center'>
                    {t('BACK_OFFICE.REPORTS.NEWSLETTERS_SENT')}
                  </div>
                </div>
                <p />
                <div className='col-md-12 flex'>
                  <h3 className='font-bold-700'>{newsletterData?.sent_count}</h3>
                </div>
                <div className='col-md-12 flex'>{/*+3% from last month*/}</div>
              </div>
              <div className='reports-in-active-athletes col-md-3'>
                <div className='col-md-12 flex bg-blue-50 min-h-10'>
                  <div className='col-md-1 content-center'>
                    <h4>
                      <LuUsers />
                    </h4>
                  </div>
                  <div className='col-md-11 right-align-text ml-5 text-blue-700 content-center'>
                    {t('BACK_OFFICE.REPORTS.NEWSLETTERS_NOT_SENT')}
                  </div>
                </div>
                <p />
                <div className='col-md-12 flex'>
                  <h3 className='font-bold-700'>{newsletterData?.not_sent_count}</h3>
                </div>
                <div className='col-md-12 flex'>{/*+3% from last month*/}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default BackOfficeReports;
